import Component from 'flarum/common/Component';
import ItemList from 'flarum/common/utils/ItemList';
import PollOption from './PollOption';
export default class PollOptions extends Component {
  view() {
    return m("div", {
      className: "Poll-options"
    }, this.pollOptions().toArray());
  }
  pollOptions() {
    const items = new ItemList();
    this.attrs.options.forEach(option => {
      items.add(`option${option.id()}`, this.createOptionView(option));
    });
    return items;
  }
  createOptionView(option) {
    return m(PollOption, {
      key: option.id(),
      name: this.attrs.name,
      option: option,
      state: this.attrs.state
    });
  }
}
flarum.reg.add('fof-polls', 'forum/components/Poll/PollOptions', PollOptions);